import type { RouteLocationRaw } from 'vue-router'
import type { BellMessageRecordVO } from '@/api/bell-message/bell-message-record'

/** Bell business type used by the independent business-exception notification contract. */
export const BUSINESS_EXCEPTION_BELL_BUSINESS_TYPE = 'BUSINESS_EXCEPTION'

/** Stable admin route for opening a business-exception work-order detail. */
export const BUSINESS_EXCEPTION_DETAIL_ROUTE = '/exception-center/processing'

/**
 * Resolves a bell record to its business-exception detail route or its legacy configured route.
 *
 * @param message bell record returned by platform-service
 * @returns route location, or null when the message has no target
 */
export function resolveBusinessExceptionNotificationRoute(
  message: Pick<BellMessageRecordVO, 'businessType' | 'businessId' | 'routePath'>
): RouteLocationRaw | string | null {
  if (message.businessType === BUSINESS_EXCEPTION_BELL_BUSINESS_TYPE && message.businessId !== undefined
    && message.businessId !== null) {
    return {
      path: BUSINESS_EXCEPTION_DETAIL_ROUTE,
      query: { exceptionId: String(message.businessId) }
    }
  }
  return message.routePath || null
}

/**
 * Normalizes a router query value to one business-exception ID.
 *
 * @param value route query value
 * @returns one non-empty ID, or null when absent
 */
export function normalizeBusinessExceptionId(value: unknown): string | null {
  const candidate = Array.isArray(value) ? value[0] : value
  if (candidate === undefined || candidate === null || String(candidate).trim() === '') {
    return null
  }
  return String(candidate)
}
